<div id="wrapper">
  <!-- <app-navbar></app-navbar> -->

  <div class="navbar-custom">
    <div class="container-fluid">
      <div class="row">
        <div class="col-6">
          <nav
            style="--bs-breadcrumb-divider: ''"
            aria-label="breadcrumb"
            class="pt-2"
          >
            <div class="breadcrumb">
              <span class="breadcrumb-item">
                <a href="javascript:void(0)">PayEXAP</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/credit-notes">Credit Notes</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/upload-credit-note">Submit Invoice</a>
              </span>
            </div>
          </nav>
        </div>
        <div class="col-6">
          <ul class="navbar-nav list-unstyled topnav-menu float-end">
            <li class="nav-item dropdown nav-user">
              <img
                src="https://github.com/mdo.png"
                alt=""
                width="32"
                height="32"
                class="rounded-circle me-2"
              />
              <span
                class="pro-user-name ms-1 dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Bharat Aluminium...
                <!-- <i
                  class="mdi mdi-chevron-down "
                  
                ></i> -->
              </span>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" routerLink="/vendor-profile">
                    <i class="ri-user-3-line"></i>
                    <span class="ml-2">Vendor Profile</span>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" routerLink="/password-change">
                    <i class="ri-lock-2-line"></i>
                    <span class="ml-2">Reset Password</span>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" routerLink="/sign-in">
                    <i class="ri-logout-box-line"></i>
                    <span class="ml-2"> Logout</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>

  <app-sidebar></app-sidebar>

  <div class="content">
    <div class="content-pane">
      <div class="container-fluid">
        <div class="upload-wrapper">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="pane-header">
                    <h4 class="py-4">Upload Credit Note</h4>
                  </div>
                  <form>
                    <div class="radio-options py-4">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                            />
                            <label
                              class="form-check-label"
                              for="flexRadioDefault1"
                            >
                              E-Invoice Credit Notes
                            </label>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                            />
                            <label
                              class="form-check-label"
                              for="flexRadioDefault1"
                            >
                              Digitally Signed Credit Note
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="upload-pane text-center py-5">
                      <div class="icon-wrapper">
                        <label for="po">
                          <i class="ri-upload-cloud-2-line"></i>
                        </label>
                        <input
                          type="file"
                          id="po"
                          class="form-control"
                          #fileInput
                          (change)="selectFile($event)"
                        />
                      </div>
                      <p>Click to choose Credit Note file</p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="loader-wrapper" *ngIf="loading">
          <div class="loader-content" *ngIf="signatureError">
            <div class="loader-text">
              <i class="ri-error-warning-fill"></i
              ><span class="ml-2">Invalid Signature</span>
            </div>
            <div class="loader-cta my-4">
              <a routerLink="/submit-invoice">
                <button class="btn btn-error">Resubmit Invoice</button>
              </a>
            </div>
          </div>

          <div class="loader-content error" *ngIf="fileTypeError">
            <div class="loader-text">
              <i class="ri-error-warning-fill"></i
              ><span class="ml-2">File Format Not Supported</span>
              <p class="text-white my-4">Allowed File type: pdf</p>
            </div>
            <div class="loader-cta my-4">
              <a routerLink="/submit-invoice">
                <button class="btn btn-error">Resubmit Invoice</button>
              </a>
            </div>
          </div>

          <div class="loader-content loading" *ngIf="validateSignature">
            <div class="loader-text">
              <span class="ml-2">Validating Credit Note</span>
              <p class="text-white my-4">Please wait a few minutes</p>
            </div>
            <div class="loader-cta my-4">
              <div class="placeholder-wave">
                <span class="placeholder col-12 placeholder-sm"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
